import axios from 'axios'
import { Product } from 'store/types'

type Config = {
  params: {
    name: string
    'google-token'?: string
  }
}

type Resp = {
  data: Product[]
}

export default async (config: Config): Promise<Resp> => {
  const response = await axios.get(`${process.env.REACT_APP_PLUSBOX_API}/products`, config)
  return response
}

export type { Config }
